import {
  type TRACKER_MESSAGE_HISTORY_RECORD_STATE_EXTENDED,
  TRACKER_MESSAGE_HISTORY_RECORD_STATE_FRONTEND,
  type TrackerMessage,
  type TrackerMessageOverview,
} from '@racemap/sdk/schema/trackers';
import type { Immutable } from 'immer';

export function getCurrentMessageStatusCode(
  message: Immutable<TrackerMessageOverview | TrackerMessage>,
): TRACKER_MESSAGE_HISTORY_RECORD_STATE_EXTENDED {
  return (
    message.historyRecords?.[0]?.statusCode ?? TRACKER_MESSAGE_HISTORY_RECORD_STATE_FRONTEND.PENDING
  );
}
